module.exports = {"title":"Restriction Setup","subcategory":"Subcategory","delete_title":"Delete Restrictions","created_at":"Date","id":"ID","stations":"Stations","create_restriction":"Create Restriction","restriction_name":"Restriction Name","type":"Type","activated_at":"Activated At","deactivated_at":"Deactivated At","tags":"Tags","outlets":"Outlets","purchase_restriction":"Purchase Restriction Records","purchase_restriction_description":"Display the restriction records created."};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/restriction.php
// module id = osWf
// module chunks = 113